var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 44V24.5514C14.5 22.3878 14.5 21.306 14.9892 20.3986C15.4783 19.4912 16.3769 18.9062 18.1739 17.7362L22.337 15.0258C23.3874 14.3419 23.9126 14 24.5 14C25.0874 14 25.6126 14.3419 26.663 15.0258L30.826 17.7362C32.6232 18.9062 33.5216 19.4912 34.0108 20.3986C34.5 21.306 34.5 22.3878 34.5 24.5514V44",
    stroke: "#3F3DA5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 26H24.518",
    stroke: "#3F3DA5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 44V34.3246C40.5 29.7414 38.6112 29.3704 34.5 28",
    stroke: "#3F3DA5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 44V34.3246C8.5 29.7414 10.3887 29.3704 14.5 28",
    stroke: "#3F3DA5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 44H44.5",
    stroke: "#3F3DA5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14V9.96443M24.5 9.96443V5.94071C24.5 4.99231 24.5 4.51811 24.7928 4.22347C25.7122 3.29879 29.5 5.48607 30.9406 6.37307C32.157 7.12211 32.5 8.61829 32.5 9.96443H24.5Z",
    stroke: "#3F3DA5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 44V38C20.5 36.1144 20.5 35.1716 21.0858 34.5858C21.6716 34 22.6144 34 24.5 34C26.3856 34 27.3284 34 27.9142 34.5858C28.5 35.1716 28.5 36.1144 28.5 38V44",
    stroke: "#3F3DA5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.c54a534f86cccf010e7a18723ae823f5.svg";
export { ForwardRef as ReactComponent };